import clsx from 'clsx';
import { FC } from 'react';
import ScrollFadeWrapper from '~/components/scroll-fade';
import WYSIWYGContent from '~/components/wysiwyg-content';
import Project from '~/data/strapi/types/collection-types/project';

import styles from './styles.module.css';

interface Props {
  project: Project;
}

const ProjectDescriptionCards: FC<Props> = ({ project }) => {
  const { task, contractor, customer, deadline, designer, solution, materials } = project;

  return (
    <div className={styles.cards}>
      {task && (
        <div className={clsx(styles.card, styles.task)}>
          <ScrollFadeWrapper className={styles.cardPadding}>
            <p className={styles.cardTitle}>Задача:</p>
            <p className={styles.cardDescription}>{task}</p>
          </ScrollFadeWrapper>
        </div>
      )}

      <div className={clsx(styles.card, styles.projectInfo)}>
        <ScrollFadeWrapper className={styles.cardPadding}>
          {customer && (
            <p>
              <span className={styles.cardTitle}>Заказчик:</span> {project.customer}
            </p>
          )}
          {designer && (
            <p>
              <span className={styles.cardTitle}>Проектировщик:</span> {project.designer}
            </p>
          )}
          {contractor && (
            <p>
              <span className={styles.cardTitle}>Подрядчик:</span> {project.contractor}
            </p>
          )}
          {deadline && (
            <p>
              <span className={styles.cardTitle}>
                Срок реализации проекта: <br />
              </span>
              {project.deadline}
            </p>
          )}
        </ScrollFadeWrapper>
      </div>
      {solution && (
        <div className={clsx(styles.card, styles.solution)}>
          <ScrollFadeWrapper className={styles.cardPadding}>
            <p className={styles.cardTitle}>Решение:</p>
            <WYSIWYGContent className={styles.cardDescription} html={solution} />
          </ScrollFadeWrapper>
        </div>
      )}

      {materials && (
        <div className={clsx(styles.card, styles.materials)}>
          <ScrollFadeWrapper className={styles.cardPadding}>
            <p className={styles.cardTitle}>Применяемые материалы:</p>
            <WYSIWYGContent className={styles.cardDescription} html={materials} />
          </ScrollFadeWrapper>
        </div>
      )}
    </div>
  );
};

export default ProjectDescriptionCards;
